import { render, staticRenderFns } from "./TopNavigation.vue?vue&type=template&id=19f9f8c9&lang=pug&"
import script from "./TopNavigation.vue?vue&type=script&lang=js&"
export * from "./TopNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TopNavigation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19f9f8c9')) {
      api.createRecord('19f9f8c9', component.options)
    } else {
      api.reload('19f9f8c9', component.options)
    }
    module.hot.accept("./TopNavigation.vue?vue&type=template&id=19f9f8c9&lang=pug&", function () {
      api.rerender('19f9f8c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TopNavigation.vue"
export default component.exports